import * as React from "react";

import { cn } from "@/lib/utils";

/**
 * TINA Skeleton — preferred over a spinner for table rows / card content.
 *
 * Compose into route-level skeletons that mirror layout (skeleton header
 * + skeleton table for list pages). Keeps layout shift to zero.
 */
function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn("animate-pulse rounded-md bg-surface-alt", className)}
      aria-hidden="true"
      {...props}
    />
  );
}

export { Skeleton };
